(() => {
  const initialize = (root) => {
    if (!root || root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
    const header = root.querySelector('.watch-header');
    const story = root.querySelector('.watch-scroll-story');
    const storyImage = root.querySelector('.watch-story-image img');
    const articles = [...root.querySelectorAll('[data-story]')];
    const markers = [...root.querySelectorAll('.watch-story-progress i')];
    const astronomyFrame = root.querySelector('.watch-astronomy-frame');
    let scheduled = false;
    const update = () => {
      scheduled = false;
      header.classList.toggle('scrolled', scrollY > 100);
      if (astronomyFrame) {
        const distance = astronomyFrame.parentElement.getBoundingClientRect().top;
        const approach = Math.max(0, Math.min(1, (innerHeight - distance) / (innerHeight * .75)));
        astronomyFrame.style.setProperty('--astronomy-approach', reduced ? 1 : approach);
      }
      const box = story.getBoundingClientRect();
      const p = Math.max(0, Math.min(.9999, -box.top / (box.height - innerHeight)));
      const index = Math.min(2, Math.floor(p * 3));
      articles.forEach((a, i) => { a.classList.toggle('active', i === index); a.setAttribute('aria-hidden', String(i !== index)); a.inert = i !== index; });
      markers.forEach((a, i) => a.classList.toggle('active', i === index));
      const poses = [{s:1.25,r:-30,x:2,y:12},{s:1.65,r:0,x:0,y:20},{s:1.55,r:42,x:12,y:-28}];
      const part = p * 3, from = poses[Math.floor(part)], to = poses[Math.min(2, Math.floor(part)+1)];
      const t = reduced ? 0 : Math.max(0, Math.min(1,(part % 1 - .65)/.35));
      const mix = k => from[k] + (to[k] - from[k]) * t;
      storyImage.style.transform = `translate(${mix('x')}%,${mix('y')}%) rotate(${mix('r')}deg) scale(${mix('s')})`;
    };
    addEventListener('scroll', () => { if (!scheduled) { scheduled = true; requestAnimationFrame(update); } }, {passive:true});
    addEventListener('resize', update); update();
    if (!reduced && 'IntersectionObserver' in window) {
      root.classList.add('watch-motion');
      const observer = new IntersectionObserver(entries => entries.forEach(e => { if(e.isIntersecting) { e.target.classList.add('visible'); observer.unobserve(e.target); } }), {threshold:.06});
      root.querySelectorAll('.watch-reveal').forEach(el => observer.observe(el));
    }
    const menu = root.querySelector('.watch-menu'), toggle = root.querySelector('.watch-menu-toggle');
    const closeMenu = () => { menu.hidden = true; toggle.setAttribute('aria-expanded','false'); };
    toggle.addEventListener('click', () => { menu.hidden = !menu.hidden; toggle.setAttribute('aria-expanded', String(!menu.hidden)); });
    menu.querySelectorAll('a').forEach(a => a.addEventListener('click',closeMenu));
    root.addEventListener('keydown',e => { if(e.key === 'Escape') closeMenu(); });
    root.querySelectorAll('[data-gallery]').forEach(gallery => {
      const track = gallery.querySelector('.watch-gallery-track');
      const slides = [...track.children];
      let index = 0;
      const go = delta => { index = Math.max(0,Math.min(slides.length-1,index+delta)); track.scrollTo({left:slides[index].offsetLeft-slides[0].offsetLeft,behavior:reduced?'instant':'smooth'}); };
      gallery.querySelector('[data-prev]').addEventListener('click',()=>go(-1));
      gallery.querySelector('[data-next]').addEventListener('click',()=>go(1));
      track.addEventListener('scroll',()=>{
        index = slides.reduce((best,el,i)=>Math.abs(el.offsetLeft-slides[0].offsetLeft-track.scrollLeft)<Math.abs(slides[best].offsetLeft-slides[0].offsetLeft-track.scrollLeft)?i:best,0);
        gallery.querySelector('[data-count]').textContent = `${String(index+1).padStart(2,'0')} / ${String(slides.length).padStart(2,'0')}`;
        gallery.querySelector('[data-prev]').disabled = index === 0;
        gallery.querySelector('[data-next]').disabled = index === slides.length-1;
      },{passive:true});
      gallery.querySelector('[data-prev]').disabled = true;
    });
    const dialog = root.querySelector('dialog'), content = dialog.querySelector('.watch-dialog-content');
    const open = node => { content.replaceChildren(node); dialog.showModal(); document.body.style.overflow='hidden'; };
    const close = () => dialog.close();
    dialog.querySelector('.watch-dialog-close').addEventListener('click',close);
    dialog.addEventListener('click',e => { if(e.target === content || e.target === dialog) close(); });
    dialog.addEventListener('close',()=>{content.replaceChildren();document.body.style.overflow='';});
    root.querySelectorAll('[data-zoom]').forEach(button=>button.addEventListener('click',()=>open(button.querySelector('img').cloneNode())));
    root.querySelector('[data-hero-zoom]').addEventListener('click',()=>root.querySelector('.watch-hero-image').click());
    const videos = [...root.querySelectorAll('.watch-video-native video')];
    const syncVideo = video => {
      const playing = video.dataset.visible === 'true' && !document.hidden;
      if (playing) {
        const source = video.querySelector('source');
        if (!source.src) { source.src = source.dataset.src; video.load(); }
        video.muted = true;
        video.play().catch(() => {});
      } else video.pause();
    };
    videos.forEach(video => {
      video.muted = true;
      video.addEventListener('playing', () => video.parentElement.classList.add('video-loaded'));
    });
    if ('IntersectionObserver' in window) {
      const videoObserver = new IntersectionObserver(entries => entries.forEach(entry => {
        entry.target.dataset.visible = String(entry.isIntersecting);
        syncVideo(entry.target);
      }), {threshold:.1});
      videos.forEach(video => videoObserver.observe(video));
    } else videos.forEach(video => { video.dataset.visible = 'true'; syncVideo(video); });
    document.addEventListener('visibilitychange', () => videos.forEach(syncVideo));
    const tabs=[...root.querySelectorAll('[data-tab]')];
    const selectTab=button=>{ tabs.forEach(t=>{ t.setAttribute('aria-selected',String(t===button));t.tabIndex=t===button?0:-1; });root.querySelectorAll('[data-panel]').forEach(p=>p.hidden=p.dataset.panel!==button.dataset.tab); };
    tabs.forEach((button,i)=>{button.addEventListener('click',()=>selectTab(button));button.addEventListener('keydown',e=>{let next;if(e.key==='ArrowRight')next=(i+1)%tabs.length;if(e.key==='ArrowLeft')next=(i+tabs.length-1)%tabs.length;if(e.key==='Home')next=0;if(e.key==='End')next=tabs.length-1;if(next!==undefined){e.preventDefault();selectTab(tabs[next]);tabs[next].focus();}});});
    const form=root.querySelector('.watch-buy');
    form.addEventListener('submit',async e=>{
      e.preventDefault();const message=form.querySelector('[role=status]'),button=form.querySelector('[type=submit]');
      if(!form.reportValidity())return;
      if(root.dataset.shopify!=='true'){message.textContent='Prévia: a compra será vinculada ao produto no Shopify.';return;}
      button.disabled=true;message.textContent='Adicionando…';
      try{const response=await fetch(root.dataset.cartAdd+'.js',{method:'POST',body:new FormData(form),headers:{Accept:'application/json'}});const result=await response.json();if(!response.ok)throw new Error(result.description||'Não foi possível adicionar ao carrinho.');message.textContent='Adicionado ao carrinho.';root.querySelector('.watch-cart-link').textContent='Ver carrinho →';document.dispatchEvent(new CustomEvent('cart:updated',{detail:{item:result}}));}
      catch(error){message.textContent=error.message;}finally{button.disabled=false;}
    });
  };
  initialize(document.querySelector('[data-watch-page]'));
  document.addEventListener('shopify:section:load',e=>initialize(e.target.querySelector('[data-watch-page]')));
})();


